import { showApiErrors } from '@/utils';
import { createSlice, isPending, isRejected, PayloadAction } from '@reduxjs/toolkit';
import { TGetStockBalancesQuery } from '../helpers/types';
import { getStockBalances } from './actionCreators';
import { initialState, STOCK_BALANCES_SLICE_NAME, StockBalancesState } from './models';

export const slice = createSlice({
  name: STOCK_BALANCES_SLICE_NAME,
  initialState,
  reducers: {
    resetState: () => initialState,
    changeQuery: (state, action: PayloadAction<TGetStockBalancesQuery>) => {
      state.query = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getStockBalances.fulfilled, (state: StockBalancesState, action) => {
        if (state.activeRequestId !== action.meta.requestId) {
          return;
        }

        state.list = action.payload.data;
        state.pagination = action.payload.meta;
        state.isLoading = false;
        state.error = null;
      })
      .addMatcher(isPending(getStockBalances), (state: StockBalancesState, action) => {
        state.isLoading = true;
        state.error = null;
        state.activeRequestId = action.meta.requestId;
      })
      .addMatcher(isRejected(getStockBalances), (state: StockBalancesState, action) => {
        state.error = action.error;
        state.isLoading = false;
        showApiErrors(action.error);
      });
  },
});

export const { resetState, changeQuery } = slice.actions;
export default slice.reducer;
